import React from 'react';

class LazyLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AsyncModule: null,
    };
    this.unmounting = false
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
    let doScroll = this.props.doScroll === undefined ? true : false
    if(doScroll) window.scrollTo(0,0)
    this.props.loader(this.props.tenantName)
      .then(module => module.default)
      .then(AsyncModule => {
        if (!this.unmounting) {
          this.setState({ AsyncModule })
        }
      })
  }

  componentWillUnmount = () => {
    this.unmounting = true
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    //alert('hi')
    let header = document.getElementById("stickyHeader");
    if (header){
    let sticky = header.offsetTop;
    if (window.pageYOffset > sticky) {
      header.classList.add("stickyHeader");
    } else {
      header.classList.remove("stickyHeader");
    }
  }
  }
  loaded = () => {
    // Injection point to put custom logic to delay display of the loaded element based on whatever conditions
    // you need to inject
    return true;
  }

  render() {
    const { loadingElement, ...childProps } = this.props;
    const { AsyncModule } = this.state;

    if (AsyncModule && this.loaded()) {
      return <AsyncModule {...this.props} {...childProps} />;
    }

    if (loadingElement) {
      const Loader = loadingElement;
      return <Loader />;
    }

    return null;
  }
}

export default LazyLoader;
